import { create } from 'zustand';

export interface InAppNotification {
  id: string;
  type: string;
  title: string;
  message: string;
  contestId?: string;
  contestName?: string;
  read: boolean;
  metadata?: Record<string, any>;
  createdAt: string;
}

interface NotificationState {
  notifications: InAppNotification[];
  unreadCount: number;
  isLoaded: boolean;

  setNotifications: (notifications: InAppNotification[], unreadCount: number) => void;
  addNotification: (notification: InAppNotification) => void;
  markAsRead: (id: string) => void;
  markAllAsRead: () => void;
  setUnreadCount: (count: number) => void;
  reset: () => void;
}

export const useNotificationStore = create<NotificationState>((set) => ({
  notifications: [],
  unreadCount: 0,
  isLoaded: false,

  setNotifications: (notifications, unreadCount) =>
    set({ notifications, unreadCount, isLoaded: true }),

  addNotification: (notification) =>
    set((state) => ({
      notifications: [notification, ...state.notifications].slice(0, 50),
      unreadCount: notification.read ? state.unreadCount : state.unreadCount + 1,
    })),

  markAsRead: (id) =>
    set((state) => {
      const n = state.notifications.find((n) => n.id === id);
      if (!n || n.read) return state;
      return {
        notifications: state.notifications.map((n) =>
          n.id === id ? { ...n, read: true } : n
        ),
        unreadCount: Math.max(0, state.unreadCount - 1),
      };
    }),

  markAllAsRead: () =>
    set((state) => ({
      notifications: state.notifications.map((n) => ({ ...n, read: true })),
      unreadCount: 0,
    })),

  setUnreadCount: (count) => set({ unreadCount: count }),

  reset: () => set({ notifications: [], unreadCount: 0, isLoaded: false }),
}));
